import React, { useEffect } from "react";
import logging from "utils/logging";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  selectAuthLoading,
  redirectToAuthFrom,
  selectUserIsAuthed,
  selectAuthUnavailable,
} from "./authSlice";
import { FullScreenSpinner } from "../components/FullScreenSpinner";
import AuthUnavailable from "./AuthUnavailable";

const log = logging.getLogger("Auth Route (Wrapper)");

/*
 * Basically this should not render it's children until/unless we get the authed user.
 * If there is no authed user, fire an event to store the URL, and redirect to the auth page.
 */
const AuthedUserRoute = ({ redirect = "/auth", children }) => {
  const dispatch = useDispatch();
  const userIsAuthed = useSelector(selectUserIsAuthed);
  const loading = useSelector(selectAuthLoading);
  const authUnavailable = useSelector(selectAuthUnavailable);
  const location = useLocation();

  useEffect(() => {
    // log.debug("useEffect on Authed User Route");
    // log.debug("path: ", location, loading, userIsAuthed);
    if (loading || authUnavailable) {
      return;
    }
    if (!userIsAuthed) {
      log.debug("redirecting to auth from... ", location.pathname);
      // The user isn't authed, they shouldn't be here
      // Save the attempted path (dispatch an action)
      dispatch(redirectToAuthFrom({ destination: location.pathname }));
      // And then redirect to /auth
    }
  }, [dispatch, userIsAuthed, loading, location]);

  if (loading) {
    return <FullScreenSpinner />;
  }

  // Auth provider couldn't initialize — show a clear error instead of
  // bouncing to a sign-in page whose Clerk widget would silently fail.
  if (authUnavailable) {
    return <AuthUnavailable />;
  }

  // log.debug("User is authed: ", userIsAuthed);

  return userIsAuthed ? children : <Navigate to={redirect} replace />;
};

export default AuthedUserRoute;
